import React from 'react';
import tabItemContentStyles from './TabItemContent.module.css';

export function TabItemContent(props) {
  return <div className={tabItemContentStyles['tab-item-content']}>{props.children}</div>;
}
